export const handleSetInstance = (id, data, setData) => {
  const instance = data.menus.filter(item => (item._id === id))
  setData(instance[0])
}

export const getActive = (id, data) => {
  const instance = data.menus.filter(item => (item._id === id))
  if(instance.length === 0) return false
  return instance[0].active
}

export const MUIColumns = (t, customBodyRenderActions) => {
  return [
    {
      name: "name", label: t('menu_table_name_column'),
      options: {
        filter: true, sort: true,
        customHeadLabelRender: (columnMeta) => <b>{columnMeta.label}</b>
      }
    },
    {
      name: "description", label: t('menu_table_description_column'),
      options: {
        filter: true, sort: true,
        customHeadLabelRender: (columnMeta) => <b>{columnMeta.label}</b>
      }
    },
    {
      name: "_id", label: t('menu_table_actions_column'),
      options: {
        filter: false, sort: false, download: false,
        customHeadLabelRender: (columnMeta) => <b>{columnMeta.label}</b>,
        customBodyRender: customBodyRenderActions
      }
    },
  ]
}